import React from "react"

import { TestableText, TestableListItem, TestableListItemPrefix } from '@components/general/TestableComponents';
import AvatarLogo from '../general/AvatarLogo';
import { Link } from "react-router-dom";

import PropTypes from "prop-types";

const MenuProjectLink = ({ project, inDrawer = false, isCollapsed = false }) => {
    const isSidebarCollapsed = isCollapsed && !inDrawer;

    return (
      <Link data-testid={`menulinks-project-${project.projectId}`} key={project.short_name} to={`/projects/${project.projectId}`}>
        <TestableListItem
          dataTestId='menulinks-project-list-item'
          className={`text-blue-500 ${isSidebarCollapsed ? 'justify-center px-1' : ''}`}>
          <TestableListItemPrefix 
            dataTestId='menulinks-project-list-item-prefix'
            className={isSidebarCollapsed ? 'mr-0 shrink-0' : ''}
            title={isCollapsed && !inDrawer ? project.title : ""}
            aria-label={isCollapsed && !inDrawer ? project.title : undefined}>
            <AvatarLogo
              alt={project.title}
              initialsCount={3}
              className="w-10 h-10"
              src={project.logo_location}
            />
          </TestableListItemPrefix>
          <TestableText 
            dataTestId='menulinks-project-list-item-text'
            variant='paragraph' 
            className={`${inDrawer || !isCollapsed ? 'block' : 'hidden'} transition-opacity duration-300`} 
            color='blue'>
              {project.short_name}
          </TestableText>
        </TestableListItem>
      </Link>
    );
}

export default MenuProjectLink;

MenuProjectLink.propTypes = {
  project: PropTypes.object.isRequired,
  inDrawer: PropTypes.bool,
  isCollapsed: PropTypes.bool,
};